import { useTranslation } from 'react-i18next';
import LeftCard from "components/MainPageCards/LeftCard";
import { ReactComponent as SuccessIcon } from 'assets/icons/success.svg';
import RightCard from "components/MainPageCards/RightCard";
import { ReactComponent as FailedIcon } from 'assets/icons/fail.svg';

const PaymentStatus = ({ status }) => {
    const { t } = useTranslation();

    const listItems = [
        {
            text: t('failed.list.insufficientFunds')
        },
        {
            text: t('failed.list.systemError')
        },
        {
            text: t('failed.list.incorrectDetails')
        }
    ];
  
    return (
        <div className="wrapper">
            <div className="container">
                <div className="payment_container">
                    {status === "success" ?
                        <LeftCard
                            MainIcon={SuccessIcon}
                            mainTitle={t('success.title')}
                            subTitle={t('success.subtitleFirst')}
                            subTitle2={t('success.subtitleSecond')}
                        />:
                        <LeftCard
                            isDottedList
                            MainIcon={FailedIcon}
                            mainTitle={t('failed.title')}
                            subTitle={t('failed.subtitleFirst')}
                            subTitle2={t('failed.subtitleSecond')}
                            list={listItems}
                        />
                    }
                    <div className='payment_right_card'>
                        <RightCard />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentStatus;